export class RestoreGceInstanceConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "zone",
            "baseName": "zone",
            "type": "string",
            "format": ""
        },
        {
            "name": "machineType",
            "baseName": "machineType",
            "type": "string",
            "format": ""
        },
        {
            "name": "labels",
            "baseName": "labels",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "networkName",
            "baseName": "networkName",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetName",
            "baseName": "subnetName",
            "type": "string",
            "format": ""
        },
        {
            "name": "networkHostProject",
            "baseName": "networkHostProject",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskSettings",
            "baseName": "diskSettings",
            "type": "Array<RestoreGcpInstanceDiskInput>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGceInstanceConfig.attributeTypeMap;
    }
    constructor() {
    }
}
